module.exports = __webpack_public_path__ + "static/media/featureIcon2.f88b3e79.png";